import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { useCurrentInboxItemDataDispute } from 'src/hooks/inboxItem';

import { DataDisputeItemInfo, VerificationRequestLink } from './shared';
import { paperStyles } from './styles';
import { DataDisputeVRConnectionStatus } from './types';
import { checkDataDisputeVerificationRequestStatus } from './utils';

export const InboxItemContentDataDisputeConsumer: React.FC = () => {
  const { dataDispute, loading } = useCurrentInboxItemDataDispute();

  const subtitleText = React.useMemo((): React.ReactElement => {
    const dataDisputeVerificationRequestStatus =
      checkDataDisputeVerificationRequestStatus(dataDispute);

    switch (dataDisputeVerificationRequestStatus) {
      case DataDisputeVRConnectionStatus.resolvedWithConnect:
        return (
          <React.Fragment>
            Employers have resolved your Data Disputes based on&nbsp;
            <VerificationRequestLink verificationRequest={dataDispute?.verificationRequest} />.
            Please note that the changes may take effect in up to 3 days.
          </React.Fragment>
        );

      case DataDisputeVRConnectionStatus.resolvedNoConnect:
        return (
          <React.Fragment>
            Employers have resolved your Data Disputes. Please note that the changes may take effect
            in up to 3 days.
          </React.Fragment>
        );

      case DataDisputeVRConnectionStatus.pendingWithConnect:
        return (
          <React.Fragment>
            Your Data Dispute Request based on&nbsp;
            <VerificationRequestLink verificationRequest={dataDispute?.verificationRequest} /> was
            sent to your current Employer
          </React.Fragment>
        );

      default:
        return (
          <React.Fragment>
            Your Data Dispute Request was sent to your current Employer
          </React.Fragment>
        );
    }
  }, [dataDispute]);

  return (
    <Paper elevation={0} sx={paperStyles}>
      {loading ? (
        <FullscreenLoader />
      ) : (
        <React.Fragment>
          <Typography variant="h6">Employer Resolution Status</Typography>

          <Typography
            fontWeight={400}
            variant="body1"
            sx={theme => ({ color: theme.palette.grey['700'] })}
          >
            {subtitleText}
          </Typography>
          <Box mt={3} display="flex" flexDirection="column" gap={3}>
            {dataDispute?.dataDisputeItemsList.map(dataDisputeInfo => (
              <DataDisputeItemInfo key={dataDisputeInfo.id} dataDisputeItem={dataDisputeInfo} />
            ))}
          </Box>
        </React.Fragment>
      )}
    </Paper>
  );
};
